import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/common/PageHeader";

export const REPORTS_TABS = [
  { label: "Lead Reports", path: "/reports/leads" },
];

export function ReportsNav() {
  const { pathname } = useLocation();
  return (
    <div className="flex items-center gap-0 px-3 sm:px-6 border-b border-slate-200 bg-white overflow-x-auto scrollbar-thin shrink-0">
      {REPORTS_TABS.map((t) => (
        <Link
          key={t.path}
          to={t.path}
          data-testid={`reports-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
          className={cn(
            "inline-flex items-center px-3 min-h-10 sm:h-9 text-[12.5px] font-medium border-b-2 -mb-px whitespace-nowrap transition-colors",
            pathname === t.path || pathname.startsWith(`${t.path}/`)
              ? "text-indigo-700 border-indigo-500"
              : "text-slate-500 border-transparent hover:text-slate-800",
          )}
        >
          {t.label}
        </Link>
      ))}
    </div>
  );
}

export function ReportsShell({ title, desc, children }) {
  return (
    <div className="flex flex-col h-full min-h-0 min-w-0 overflow-hidden" data-testid="reports-shell">
      <PageHeader title={title} description={desc} />
      <ReportsNav />
      <div className="flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden scrollbar-thin">
        {children}
      </div>
    </div>
  );
}

ReportsShell.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  children: PropTypes.node,
};
